"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeIsoWeekRange = exports.getIsoWeekNumber = void 0;
const getIsoWeekNumber = (date) => {
    const target = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
    const dayNr = target.getUTCDay() || 7;
    target.setUTCDate(target.getUTCDate() + 4 - dayNr);
    const yearStart = new Date(Date.UTC(target.getUTCFullYear(), 0, 1));
    const week = Math.ceil((((target.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
    return { week, year: target.getUTCFullYear() };
};
exports.getIsoWeekNumber = getIsoWeekNumber;
const computeIsoWeekRange = (weekOffset = 0, reference = new Date()) => {
    const day = reference.getUTCDay() || 7;
    const monday = new Date(Date.UTC(reference.getUTCFullYear(), reference.getUTCMonth(), reference.getUTCDate() - (day - 1) - weekOffset * 7, 0, 0, 0, 0));
    const nextMonday = new Date(monday.getTime() + 7 * 24 * 3600 * 1000);
    const { week, year } = (0, exports.getIsoWeekNumber)(monday);
    return { start: monday, end: nextMonday, isoNumber: week, isoYear: year };
};
exports.computeIsoWeekRange = computeIsoWeekRange;
